import { UserActionRequiredErrorCode, UserActionRequiredErrorDto } from '../dto'

type UserActionRequiredTranslationKeys = {
  [key in UserActionRequiredErrorCode]: {
    title: string
    message: string
  }
}

const translationKeys: UserActionRequiredTranslationKeys = {
  26026: {
    title: 'vehicle-integration.vehicles.user-action-needed-title',
    message: 'vehicle-integration.vehicles.user-action-needed-message',
  },
  26027: {
    title: 'vehicle-integration.vehicles.location-not-shared-in-manufacturer-app-title',
    message: 'vehicle-integration.vehicles.location-not-shared-in-manufacturer-app-message',
  },
}

export const getTranslationBasedOnUserActionRequiredErrorCodes = (
  errors: UserActionRequiredErrorDto[]
): { title: string; message: string }[] | [] => {
  const validErrors = errors.filter(error => error.errorCode in translationKeys)

  return validErrors.map(error => translationKeys[error.errorCode])
}
